export default "__VITE_PUBLIC_ASSET__36c6fb75__"